export const REQUEST_CHECK_SUMMARY = 'REQUEST_CHECK_SUMMARY';
export const CHECK_SUMMARY_RECEIVED = 'CHECK_SUMMARY_RECEIVED';

